import { ReactNode } from 'react';
import ChatIcon from '@stripcash/ui-kit/icons/chat.svg';
import TelegramIcon from '@stripcash/ui-kit/icons/telegram.svg';
import QuestionIcon from '@stripcash/ui-kit/icons/question.svg';

import HeaderButton from 'common/components/Header/components/HeaderButton';
import { Translate } from 'common/i18n/types';

import ContactUs from '../ContactUs';

type renderHeaderChildrenProps = {
  t: Translate;
  isWideMobile: boolean;
};

const renderHeaderChildren = ({
  t,
  isWideMobile,
}: renderHeaderChildrenProps): ReactNode[] => [
  <HeaderButton
    title={t('userAgreement.blog')}
    icon={<ChatIcon />}
    linkProps={{
      href: '/blog',
      target: '_blank',
      rel: 'noreferrer',
    }}
  />,
  <HeaderButton
    title={t('userAgreement.telegram')}
    icon={<TelegramIcon size={12} />}
    linkProps={{
      href: 'https://t.me/stripcashnews',
      target: '_blank',
      rel: 'noreferrer',
    }}
  />,
  <HeaderButton
    title={t('userAgreement.faq')}
    icon={<QuestionIcon />}
    linkProps={{
      href: '/faq',
      target: '_blank',
      rel: 'noreferrer',
    }}
  />,
  ...(isWideMobile ? [] : [<ContactUs t={t} />]),
];

export default renderHeaderChildren;
